import { Input, TextField } from '@shared/ui/kit';
import { CustomDropdown } from '@shared/ui/dropdown';
import { OUTLOOK_TIME_SLOT_OPTIONS, type OutlookTimeSlotOption } from '../../lib/outlook-meeting';
import { LockedDateField } from '../shared/locked-date-field';
import styles from './outlook-meeting-settings-section.module.scss';

export interface OutlookMeetingSettingsValues {
  eventMeetingDate: Date | null;
  outlookMeetingStartTime: OutlookTimeSlotOption | null;
  outlookMeetingEndTime: OutlookTimeSlotOption | null;
  outlookMeetingLocationOrLink: string;
  outlookMeetingComment: string;
}

export interface OutlookMeetingSettingsActions {
  onOutlookMeetingStartTimeChange: (option: OutlookTimeSlotOption | null) => void;
  onOutlookMeetingEndTimeChange: (option: OutlookTimeSlotOption | null) => void;
  onOutlookMeetingLocationOrLinkChange: (value: string) => void;
  onOutlookMeetingCommentChange: (value: string) => void;
}

interface OutlookMeetingSettingsSectionProps {
  values: OutlookMeetingSettingsValues;
  actions: OutlookMeetingSettingsActions;
  readOnly?: boolean;
}

export const OutlookMeetingSettingsSection = ({
  values,
  actions,
  readOnly = false,
}: OutlookMeetingSettingsSectionProps) => {
  const {
    eventMeetingDate,
    outlookMeetingStartTime,
    outlookMeetingEndTime,
    outlookMeetingLocationOrLink,
    outlookMeetingComment,
  } = values;
  const {
    onOutlookMeetingStartTimeChange,
    onOutlookMeetingEndTimeChange,
    onOutlookMeetingLocationOrLinkChange,
    onOutlookMeetingCommentChange,
  } = actions;

  return (
    <section className={styles.settingsCard}>
      <h2 className={styles.settingsCardTitle}>Настройка встречи в Outlook</h2>
      <div className={styles.sectionsColumn}>
        <div className={styles.topRow}>
          <div className={styles.dateCell}>
            <LockedDateField label="Дата встречи" date={eventMeetingDate} />
          </div>
          <div className={styles.timeDropdowns}>
            <div className={styles.timeDropdownWrap}>
              <CustomDropdown
                labelMessage="Начало"
                placeholder="Выбрать"
                options={OUTLOOK_TIME_SLOT_OPTIONS}
                itemText="label"
                itemValue="value"
                value={outlookMeetingStartTime}
                fullWidth
                isRadio={false}
                listMaxHeight="180px"
                isDisabled={readOnly}
                changeFunc={onOutlookMeetingStartTimeChange}
              />
            </div>
            <div className={styles.timeDropdownWrap}>
              <CustomDropdown
                labelMessage="Окончание"
                placeholder="Выбрать"
                options={OUTLOOK_TIME_SLOT_OPTIONS}
                itemText="label"
                itemValue="value"
                value={outlookMeetingEndTime}
                fullWidth
                isRadio={false}
                listMaxHeight="180px"
                isDisabled={readOnly}
                changeFunc={onOutlookMeetingEndTimeChange}
              />
            </div>
          </div>
        </div>

        <div className={styles.fullWidthField}>
          <Input
            size="small"
            labelText=""
            placeholder="Добавить место или ссылку на встречу"
            value={outlookMeetingLocationOrLink}
            changeFunction={onOutlookMeetingLocationOrLinkChange}
            isDisabled={readOnly}
            settings={{ width: '100%' }}
          />
        </div>

        <div className={styles.fullWidthField}>
          <TextField
            labelMsg="Комментарий"
            placeholder="Введите текст"
            value={outlookMeetingComment}
            changeFunction={(event) => onOutlookMeetingCommentChange(event.target.value)}
            isDisabled={readOnly}
            settings={{
              width: '100%',
              cursor: 'text',
              resize: 'vertical',
              height: 'auto',
              minHeight: '75px',
              overflow: 'auto',
            }}
          />
        </div>
      </div>
    </section>
  );
};
